<template>
  <div class="bsdwzCN">
    <p class="bt1">1、需要解决的视觉问题有:</p>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[0]" @input="(v) => $set(form.InquiryIntention, 0, v ? true : false)"> 看远模糊</el-checkbox>
        <span>度数变化;眼健康问题</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[1]" @input="(v) => $set(form.InquiryIntention, 1, v ? true : false)">看近模糊</el-checkbox>
        <span>双眼视功能异常</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[2]" @input="(v) => $set(form.InquiryIntention, 2, v ? true : false)">视物变形</el-checkbox>
        <span>散光度数变化;镜片老化变形</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[0]" @input="(v) => $set(form.InquiryIntention, 0, v ? true : false)">胀疼疲劳</el-checkbox>
        <span style="width: 90%;">排查双眼视功能异常;度数未正确矫正;老花未矫正;眼压异常</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[1]" @input="(v) => $set(form.InquiryIntention, 1, v ? true : false)">眼睛痒</el-checkbox>
        <span>干眼问题;眼表疾病</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[2]" @input="(v) => $set(form.InquiryIntention, 2, v ? true : false)">怕光</el-checkbox>
        <span>屈光不正;弱视;角膜健康问题;激光手术术后</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[0]" @input="(v) => $set(form.InquiryIntention, 0, v ? true : false)">视物扭曲变形</el-checkbox>
        <span>散光度数变化;镜片老化变形;黄斑病变;</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[1]" @input="(v) => $set(form.InquiryIntention, 1, v ? true : false)">夜间视力差</el-checkbox>
        <span>屈光术后眩光;度数未正确矫正;高阶像差;夜盲症</span>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[2]" @input="(v) => $set(form.InquiryIntention, 2, v ? true : false)">听力问题的困扰</el-checkbox>
        <span>是否有听力损伤,如果有需要检查听力</span>
      </p>
    </div>
    <div class="sjwt">
      <p>
        <el-checkbox :value="!!form.InquiryIntention[0]" @input="(v) => $set(form.InquiryIntention, 0, v ? true : false)">验光配镜</el-checkbox>
      </p>
      <p>
        <el-checkbox :value="!!form.InquiryIntention[1]" @input="(v) => $set(form.InquiryIntention, 1, v ? true : false)"> 复查管理</el-checkbox>
      </p>
      <p></p>
    </div>
    <div class="qitsq">
      <p>本次其他主诉需求:</p>
      <input type="text" v-model="form.InquiryIntentionDes">
    </div>



    <p class="bt1" style="margin-top: 30px;">2、旧镜史相关:</p>
    <div class="slxgbox" style="border-bottom: none; ">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.既往矫正方式</p>
        <p>了解既往矫正方式是否对本次验光准确性有影响,为本次矫正方式选择提供参考</p>
        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="familyEyeDiseaseList">
            <el-checkbox label="框架眼镜"></el-checkbox>
            <el-checkbox label="软性角膜接触镜"></el-checkbox>
            <el-checkbox label="RGP"></el-checkbox>
            <el-checkbox label="OK镜"></el-checkbox>
            <el-checkbox label="屈光手术"></el-checkbox>
          </el-checkbox-group>
        </div>
        <input style="width: 100%;margin-top: 20px;" type="text">
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.既往矫正方式</p>
        <p>了解既往矫正方式是否对本次验光准确性有影响,为本次矫正方式选择提供参考</p>
        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="familyEyeDiseaseList">
            <el-checkbox label="单光"></el-checkbox>
            <el-checkbox label="自由曲面"></el-checkbox>
            <el-checkbox label="数码"></el-checkbox>
            <el-checkbox label="渐进"></el-checkbox>
            <el-checkbox label="染色"></el-checkbox>
            <el-checkbox label="变色"></el-checkbox>
            <el-checkbox label="驾驶"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴清晰度：</p>
        <p>度数变化、眼健康问题,为本次验光度数调整提供依据;</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" label="不清">不清</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="良好">良好</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.配戴舒适度：</p>
        <p>了解旧镜配戴方式、镜架镜片选择等是否能提供舒适视觉,如果有问题,本次需针对检查并解决</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" label="不清">不清</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="良好">良好</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次换镜需要适应多长时间:</p>
        <p>了解眼睛适应能力,为本次处方提供参考</p>
      </div>
      <div><input type="text" v-model="form.InquiryVisualMonth">天</div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每次换镜度数是否变化:</p>
        <p>看是否及时更换眼镜;评估度数稳定情况</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeFullCheck" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeFullCheck" :label="false">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.常戴的眼镜有几副?</p>
        <p>了解不同用眼场景是否有对应功能的眼镜</p>
      </div>
      <div><input type="text" v-model="form.InquiryVisualMonth">副</div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.看近是否摘眼镜?</p>
        <p>了解是否有近疲劳(老花);是否有双眼视功能异常</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeFullCheck" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeFullCheck" :label="false">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.眼镜是否全天候配戴?</p>
        <p>评估度数变化是否与不正确配戴方式有关;评估新镜适应情况</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeFullCheck" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeFullCheck" :label="false">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.现在的眼镜是否有以下问题：</p>
        <p>评估旧镜视力是否有参考价值</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" label="变形">变形</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="磨损">磨损</el-radio>
      </div>
    </div>


    <p class="bt1" style="margin-top: 30px;">3、用眼需求相关:</p>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天开车多长时间?</p>
        <p>了解远用视力需求;了解是否有驾驶需求</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" label="基本不开">基本不开</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="一个小时以上">一个小时以上</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="3个小时以上">3个小时以上</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.夜间开车是否有以下问题?</p>
        <p>是否需要使用驾驶镜片来解决驾驶安全问题</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" label="眩光">眩光</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="光晕">光晕</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="3个小时以上">光线刺眼</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.每天电脑、手机及近距离伏案工作时长</p>
        <p>了解近距离用眼量,评估双眼视功能和用眼需求是否匹配</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryBornJaundice" label="很少">很少</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="2小时以内">2小时以内</el-radio>
        <el-radio v-model="form.InquiryBornJaundice" label="4个小时以上">4个小时以上</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.是否有关灯看手机电脑的习惯?</p>
        <p>否有不良用眼习惯,影响眼健康</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeFullCheck" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeFullCheck" :label="false">否</el-radio>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a" style="width: 100%;">
        <p>.近距离用眼是否有以下问题?</p>
        <p>了解是否有双眼视功能异常的相关症状,好针对性的检查和处理</p>
        <div style="display: flex;padding-top: 10px;">
          <el-checkbox-group v-model="familyEyeDiseaseList">
            <el-checkbox label="易疲劳"></el-checkbox>
            <el-checkbox label="头疼"></el-checkbox>
            <el-checkbox label="聚焦困难"></el-checkbox>
            <el-checkbox label="重影串行"></el-checkbox>
            <el-checkbox label="注意力不集中"></el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <div class="slxgbox">
      <div class="slxgbox-a">
        <p>.视线远近交替是否有模糊,反应速度慢?</p>
        <p>了解是否有调节灵敏度的异常,好针对性的检查和处理</p>
      </div>
      <div style="padding-top: 10px;">
        <el-radio v-model="form.InquiryEyeFullCheck" :label="true">是</el-radio>
        <el-radio v-model="form.InquiryEyeFullCheck" :label="false">否</el-radio>
      </div>
    </div>






  </div>
</template>


<script>
export default {
  name: "bsdwzCN",
  data() {
    return {
      form: {
        InquiryIntention: []
      },
      familyEyeDiseaseList: []
    }
  }
}
</script>


<style scoped lang="scss">
.bsdwzCN {
  width: 90%;
  margin: 0 auto;
  padding-bottom: 20px;
}

.bt1 {
  text-align: left;
  padding: 5px 10px;
  background: #e5e5e5;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 20px;
}
.sjwt {
  display: flex;
  text-align: left;
  padding-bottom: 15px;
  p {
    width: 33%;
    span {
      display: block;
      font-size: 13px;
      color: #8eb2ff;
      padding-left: 25px;
    }
  }
}

.qitsq {
  display: flex;
  align-content: center;
  input {
    width: calc(100% - 150px);
    margin-left: 20px;
    border: none;
    border-bottom: 1px solid #000000;
  }
}

.slxgbox {
  display: flex;
  align-content: center;
  text-align: left;
  border-bottom: 1px dashed #818181;
  padding-bottom: 5px;
  margin-bottom: 10px;
  .slxgbox-a {
    width: 62%;
    p{color: #8eb2ff;font-size: 14px;}
    p:nth-child(1) {color: #000000;}
  }
  input {
    width: 50px;
    border: none;
    border-bottom: 1px solid #000000;
    text-align: center;
  }
}

</style>